import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { api, imageUrl } from "../lib/api";
import { useSEO, buildBreadcrumbsJsonLd } from "../lib/seo";
import { pageFaqJsonLd, useFaqs } from "../lib/faqs";
import { COMPANY, SITE_URL } from "../lib/constants";
import { CITY_PATH_RE, cityPath, useCityPage } from "../lib/werkgebied";
import { CityView, cityCrumbs } from "../components/werkgebied/CityView";
import NotFound from "./NotFound";

export const cityImageUrl = (image) => (image?.path ? (image.path.startsWith("/") ? SITE_URL + image.path : imageUrl(image.path)) : undefined);

const serviceLd = (page, path) => ({
  "@context": "https://schema.org", "@type": "Service", name: page.h1, url: SITE_URL + path, description: page.seo_description,
  serviceType: "Levering en montage van kunststof en aluminium kozijnen, schuifpuien en deuren",
  areaServed: { "@type": "City", name: page.name, containedInPlace: { "@type": "AdministrativeArea", name: "Zuid-Holland" } },
  provider: { "@type": "HomeAndConstructionBusiness", "@id": `${SITE_URL}/#localbusiness`, name: COMPANY.name,
    address: { "@type": "PostalAddress", addressLocality: COMPANY.locality, addressRegion: "Zuid-Holland", addressCountry: "NL" } },
});

// Actieve, niet-verlopen aanbieding uit Beheer → Aanbiedingen (de backend filtert verlopen acties).
const useOffer = (slug) => {
  const [offer, setOffer] = useState(null);
  useEffect(() => {
    let on = true;
    api.get(`/offers/${slug}`).then((r) => on && setOffer(r.data)).catch(() => on && setOffer(null));
    return () => { on = false; };
  }, [slug]);
  return offer;
};

const CityLoaded = ({ page }) => {
  const path = cityPath(page.slug);
  const faqs = useFaqs(path);
  const offer = useOffer(page.slug);
  useSEO({
    title: page.seo_title || `Kunststof kozijnen ${page.name} | ${COMPANY.name}`, description: page.seo_description, path,
    ogImage: cityImageUrl(page.image), noindex: page.indexable === false, jsonLd: serviceLd(page, path),
    faqJsonLd: pageFaqJsonLd(faqs, path), breadcrumbs: buildBreadcrumbsJsonLd(cityCrumbs(page)),
  });
  return <CityView page={page} faqs={faqs} offer={offer} />;
};

export default function CityPage({ citySlug }) {
  const page = useCityPage(citySlug);
  if (page === "missing") return <NotFound />;
  if (!page) return <div className="min-h-[70vh]" data-testid="city-loading" />;
  return <CityLoaded page={page} />;
}

export const CityRoute = () => {
  const { pathname } = useLocation();
  const m = pathname.match(CITY_PATH_RE);
  return m ? <CityPage citySlug={m[1]} /> : <NotFound />;
};
